import { ROLE, Role, RoleTree } from './roles';

// Flatten role inheritance tree — single-pass, no recursion
export const buildInheritanceMap = (): Record<Role, Role[]> => {
  const map: Record<Role, Set<Role>> = {} as Record<Role, Set<Role>>;

  for (const role of Object.values(ROLE)) {
    const inherited = new Set<Role>();
    const stack = [role];

    while (stack.length > 0) {
      const current = stack.pop()!;
      if (!inherited.has(current)) {
        inherited.add(current);
        stack.push(...(RoleTree[current] || []));
      }
    }

    map[role] = inherited;
  }

  // Convert sets to arrays, to make it easier to work with
  return Object.fromEntries(Object.entries(map).map(([role, set]) => [role, [...set]])) as Record<Role, Role[]>;
};
